import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useLocales } from '../locales';

type SelectionBarProps = {
  countSelected: number;
  actions?: React.ReactNode;
  onSelectedClick?: () => void;
  selectedActive?: boolean;
};

export default function SelectionBar({
  actions,
  countSelected,
  onSelectedClick,
  selectedActive,
}: SelectionBarProps) {
  const { translate } = useLocales();
  const canClickSelected = Boolean(onSelectedClick) && countSelected > 0;
  const isSelectedActive = Boolean(selectedActive) && countSelected > 0;

  let selectedTextColor: string = 'text.disabled';
  if (countSelected > 0) selectedTextColor = 'error.dark';
  if (isSelectedActive) selectedTextColor = 'common.white';
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        height: 40,
        borderRadius: 1,
        flexGrow: 1,
        paddingX: 1,
        bgcolor: 'primary.lighter',
      }}
    >
      {actions}
      <Typography
        variant="body2"
        onClick={canClickSelected ? onSelectedClick : undefined}
        sx={{
          fontWeight: 'bold',
          color: selectedTextColor,
          whiteSpace: 'nowrap',
          flexShrink: 0,
          ml: 2,
          ...(isSelectedActive && {
            bgcolor: 'error.dark',
            borderRadius: 1,
            px: 1,
            py: 0.25,
          }),
          ...(canClickSelected && { cursor: 'pointer' }),
        }}
      >
        {`${countSelected} ${translate('selectedShort')}`}
      </Typography>
    </Stack>
  );
}
